import MenuIcon from '@mui/icons-material/Menu'
import { IconButton, AppBar as MuiAppBar, Toolbar, Typography } from '@mui/material'
import { useMediaQuery, useTheme } from '@mui/system'
import { useLocation } from 'react-router'

type AppBarProps = {
  burgerMenu?: boolean
  onToggleDrawer: () => unknown
}

export const AppBar = ({ burgerMenu = false, onToggleDrawer }: AppBarProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const { pathname } = useLocation()
  const isHome = pathname === '/' || pathname === '/dashboard' || pathname === '/admin/dashboard'

  return (
    <MuiAppBar
      position="static"
      style={{
        background: 'linear-gradient(100deg, rgba(81,36,122,1) 70%, rgba(150,42,139,1) 100%)',
        boxShadow: 'none',
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={onToggleDrawer}
          sx={burgerMenu || isMobile ? { display: 'block', top: 2 } : { display: 'none' }}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component={isHome ? 'h1' : 'span'}
          variant="h3"
          color="inherit"
          noWrap
          sx={{ ml: 2, fontWeight: '100', textShadow: '1px 1px 3px #333333' }}
        >
          UQ Research Data Manager
        </Typography>
      </Toolbar>
    </MuiAppBar>
  )
}
